import React from "react";
import { createWebLink, getDomainName, ucword } from "../lib/helper";

const ChurchInfo = ({ church }) => {
  const leadPastors = church?.churchPastorConfigs
    ?.filter((item) => item.type == "LEAD")
    .map((item) => item?.pastorDetail.name);

  return (
    <div className="flex flex-col mx-auto max-w-7xl px-2 md:px-4 gap-2">
      <div className="py-4 border-b-2 border-gray-200">
        <h2 className="text-xl font-semibold">Learn More</h2>
      </div>
      <div>
        <h1 className="text-xl md:text-2xl font-semibold capitalize">
          {church.name}
        </h1>
      </div>
      {leadPastors?.length > 0 ? (
        <div>
          <p className="md:text-lg">
            <span className="font-semibold">Lead Pastor(s): </span>
            <span className="capitalize">{ucword(leadPastors.join(","))}</span>
          </p>
        </div>
      ) : (
        ""
      )}
      <div>
        <p className="md:text-lg">
          <span className="font-semibold">Address: </span>
          <span>
            {church?.address ? church?.address + "," : ""}{" "}
            {church?.city ? church?.city + "," : ""}{" "}
            {church.state && church.state.abbreviation} {church.zip}
          </span>
        </p>
      </div>
      {church.website && (
        <div>
          <p className="md:text-lg">
            <span className="font-semibold">Website: </span>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={createWebLink(church.website)}
              className="text-blue-600 tx-sm"
            >
              {getDomainName(church.website)}
            </a>
          </p>
        </div>
      )}
      {church.churchLanguageConfigs.length > 0 && (
        <div>
          <p className="md:text-lg">
            <span className="font-semibold">Languages: </span>
            <span>
              {" "}
              {church.churchLanguageConfigs
                .map((item) => item?.language.name)
                .join(", ")}{" "}
            </span>
          </p>
        </div>
      )}
      {church.description && (
        <div>
          <p className="md:text-lg">
            <span className="font-semibold">Description: </span>
            <br />
            <span>{church.description}</span>
          </p>
        </div>
      )}
    </div>
  );
};

export default ChurchInfo;
